import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
export function MenuInput({ children, handleChange, multiple, accept, }) {
    return (_jsxs("div", { children: [_jsx("input", { multiple: multiple, type: "file", hidden: true, onChange: handleChange, id: "raised-button-file", accept: accept }), _jsx("label", Object.assign({ htmlFor: "raised-button-file" }, { children: children }))] }));
}
